import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import viewOff from '../../assets/images/view-off-icon.svg';
import viewOn from '../../assets/images/view-on-icon.svg';
import Button from '../../components/ui/Button';
import CustomInput from '../../components/ui/CustomInput';
import PageLayout from '../../components/ui/PageLayout';
import { ApiConstants } from '../../constants/ApiConstants';
import { Routes } from '../../constants/RouteConstants';
import useMakeRequest from '../../utils/ApiHelper';
import ChangePasswordValidation from '../../validations/auth/ChangePasswordValidation';


interface ChangePassowrdInputs {
  old_password: string;
  password: string;
  confirm_password: string
};



const ChangePassword = () => {

  const [oldPasswordShow, setOldPassworShow] = useState(false)
  const [newPasswordShow, setNewPassworShow] = useState(false)
  const [confirmPasswordShow, setConfirmPassworShow] = useState(false)

  const changePassword = useMakeRequest();
  const navigate = useNavigate()

  const { register, formState: { errors }, handleSubmit, reset } = useForm<ChangePassowrdInputs>({
    mode: 'onChange', resolver: yupResolver(ChangePasswordValidation)
  });

  const onSubmit = (payload: any) => {
    toast.promise(
      changePassword.makeRequest({ payload, url: ApiConstants?.ChangePassword }),
      {
        loading: 'Changing password...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
  }
  useEffect(() => {
    if (changePassword?.status) {
      reset();
      navigate(Routes?.Profile)

    }
  }, [changePassword?.status])

  return (
    <>
      <PageLayout headerName='Set a New Password' onlyTitle={false}>
        {/* <TopHeader headerName="Set a New Password" showMenuOption={false} /> */}
        <div className="auth-page change-password-page">
          <div className="auth-container">
            <p className='auth-sub-para'>Set a new password for your account.</p>

            <form className='auth-form-wrap' onSubmit={handleSubmit(onSubmit)}>
              <div className="auth-form">
                <div className="auth-form-fields">
                  <CustomInput
                    label="Old Password"
                    type={oldPasswordShow ? 'text' : 'password'}
                    placeholder="**********"
                    required
                    {...register('old_password')}
                    error={errors.old_password?.message}
                    icon={
                      oldPasswordShow ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                    }
                    onIconClick={() => setOldPassworShow(!oldPasswordShow)}
                  />

                  <CustomInput
                    label="Password"
                    type={newPasswordShow ? 'text' : 'password'}
                    placeholder="**********"
                    required
                    {...register('password')}
                    error={errors.password?.message}
                    icon={
                      newPasswordShow ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                    }
                    onIconClick={() => setNewPassworShow(!newPasswordShow)}
                  />

                  <CustomInput
                    label="Confirm Password"
                    type={confirmPasswordShow ? 'text' : 'password'}
                    placeholder="**********"
                    required
                    {...register('confirm_password')}
                    error={errors.confirm_password?.message}
                    icon={
                      confirmPasswordShow ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                    }
                    onIconClick={() => setConfirmPassworShow(!confirmPasswordShow)}
                  />
                </div>
                <div className="auth-form-actions">
                  <Button type='submit' text='Submit' loading={changePassword?.loading} className='com-btn' disabled={changePassword?.loading}>Submit</Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageLayout>
    </>
  )
}

export default ChangePassword